"use client";

import { useMemo } from "react";
import { useVisibleSettingsNavItems } from "@/hooks/use-visible-settings-nav-items";
import { useVisibleFeatureNavItems } from "@/hooks/use-visible-feature-nav-items";

export interface CommandBarPage {
  /** Stable, namespaced key (unique across settings + feature pages). */
  id: string;
  title: string;
  href: string;
}

/**
 * The navigable settings + feature pages for the command bar, gated by the same
 * rules the sidebars use.
 */
export function useCommandBarPages(): CommandBarPage[] {
  const visibleSettings = useVisibleSettingsNavItems();
  const visibleFeatures = useVisibleFeatureNavItems();

  return useMemo(() => {
    const settings: CommandBarPage[] = visibleSettings.map((item) => ({
      id: `settings-${item.id}`,
      title: item.title,
      href: item.href,
    }));

    const features: CommandBarPage[] = visibleFeatures.map((item) => ({
      id: `feature-${item.id}`,
      title: item.title,
      href: item.url,
    }));

    return [...features, ...settings];
  }, [visibleSettings, visibleFeatures]);
}
